import { PostMessageOptions } from "."

export function handleOpenStartPage({ props, data }: PostMessageOptions) {
    if (data.openStartPage) {
        props.history.push("/")
    }
}
